import { isEmpty, isNull } from "lodash";

// 메뉴(페이지) 접근 권한 판정 — Sidebar.roleCheck에서 추출한 공용 로직.
//   userAccess: userService.getUserAccessRoles 응답 ({ roles: [...], excludes: [...] })
//   appRoles/userRoles: TabMenuList 메뉴 정의의 롤 배열, reduxKey: 메뉴 식별자(excludes 매칭용)
const roleCheck = (userAccess, appRoles, userRoles, reduxKey) => {
  let appPermission = false;
  let userPermission = false;
  if (isNull(userAccess)) {
    return false;
  }
  if (userAccess.excludes?.includes(reduxKey)) {
    return false;
  }

  if (isEmpty(appRoles) || appRoles?.includes("ALL")) {
    appPermission = true;
  }

  if (isEmpty(userRoles) || userRoles?.includes("ALL")) {
    userPermission = true;
  }

  if (appPermission && userPermission) {
    return true;
  }

  userAccess.roles?.forEach((role) => {
    if (appRoles?.includes(role)) {
      appPermission = true;
    }

    if (userRoles?.includes(role)) {
      userPermission = true;
    }
  })

  return appPermission && userPermission;
}

const menuAccessUtil = { roleCheck };
export default menuAccessUtil;
